<template>
  <div class="auth-config-box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="审批模板" name="first">
              <el-table :data="approvalTemplateList" :border="true" ref="approvalTable" height="60vh" style="margin-top:-10px" @selection-change="handleSelectionChange">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                  <el-table-column
                    label="模板名称"
                    :show-overflow-tooltip="true"
                    align="left"
                    width="400">
                    <template slot-scope="scope">
                        <span style="font-weight: 700;color:#303133;font-size:16px;">{{ scope.row.templateName }}</span>
                    </template>
                  </el-table-column>
                   <el-table-column
                      prop="busiTypeName"
                      width="200"
                      label="审批类型"
                      align="center"
                    >
                  </el-table-column>
                   <el-table-column
                    label="发布状态"
                    width="90">
                    <template slot-scope="scope">
                       <el-tag type="success" v-if="scope.row.templateState==1">已发布</el-tag>
                       <el-tag type="info"  v-else>未发布</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="审批流顺序"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-steps v-if="scope.row.approvalMethod != 2 && scope.row.approvalTotalNum>0" :active="scope.row.approvalTotalNum" align-center>
                            <el-step v-for="(item, index) in scope.row.users" :key="index" :title="item.trueName"></el-step>
                        </el-steps>
                        <el-steps v-if="scope.row.approvalMethod == 2 && scope.row.approvalTotalNum>0" :active="scope.row.approvalTotalNum" align-center>
                            <el-step v-for="(item, index) in scope.row.approvalList"  :key="index" align-center >
                                <el-breadcrumb v-if="item && item.length > 0" slot="title" :separator="(scope.row.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                    <el-breadcrumb-item  v-for="(user, i) in item" :key="i">{{user.trueName}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </el-step>
                        </el-steps>
                        <el-steps v-if="scope.row.approvalMethod == 3 && scope.row.approvePeopleList.length>0" :active="scope.row.approvePeopleList.length" align-center>
                            <el-step v-for="(item, index) in scope.row.approvePeopleList"  :key="index" align-center >
                                <el-breadcrumb v-if="item.approvePeoples && item.approvePeoples.length > 0" slot="title" :separator="(item.approveWay == 2?'+':'/')">
                                    <el-breadcrumb-item  v-for="(user, i) in item.approvePeoples" :key="i">{{user.approvePeopleType=='user'?user.selectedUserName:user.fieldName}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </el-step>
                        </el-steps>
                    </template>
                  </el-table-column>
                </el-table>
        </el-tab-pane>
        <el-tab-pane label="流程模板" name="second">
            <el-table :data="businessTemplateList" :border="true"  ref="businessTable" height="60vh" style="margin-top:-10px" @selection-change="handleSelectionChangeBusiness">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column prop="serviceName" label="流程方案名称" :show-overflow-tooltip="true" min-width="120"></el-table-column>
                <el-table-column prop="definitionName" label="所属流程定义" :show-overflow-tooltip="true" min-width="110"></el-table-column>
                <el-table-column prop="businessName" label="业务分类" :show-overflow-tooltip="true" min-width="85" ></el-table-column>
                <el-table-column prop="processServiceUserNames" label="已授权" :show-overflow-tooltip="true" align="left" min-width="120"></el-table-column>
                <el-table-column prop="trueName" label="创建人" :show-overflow-tooltip="true" width="70"></el-table-column>
                <el-table-column prop="created" label="创建时间" :show-overflow-tooltip="true" :sortable="true" min-width="90"></el-table-column>
            </el-table>
        </el-tab-pane>
      </el-tabs>
  </div>
</template>
<script>
import { isEmpty } from 'lodash';
import { getProcessServiceList, getApprovalTemplateList, getSonTempData } from '@/data-model';
export default {
    data () {
        return {
            activeName: 'first',
            approvalTemplateList: [],
            businessTemplateList: [],
            approvalChooseData: [],
            businessChooseData: []
        };
    },
    props: {
        sonAccountObj: {
            type: Object
        }
    },
    created () {
        this.initData();
    },
    methods: {
        initData () {
            // 1.获取授权的审批流模板列表
            this.getApprovalTemp();
        },
        async getBusinessTemp (loading) {
            // let loading = this.$loading({
            //     lock: true,
            //     text: 'Loading',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.7)'
            // });
            // console.log(this.sonAccountObj);
            let searchParams = {currentPage: 1, pageSize: 1000, processDefinitionId: '', serviceName: '', producer: '', serviceType: '', state: 1, unNeedAuth: true};
            let { data } = await getProcessServiceList(searchParams);
            console.log(data);
            this.businessTemplateList = data;
            // 3.回显已经配置过的模板
            this.getSonTempData(loading);
            // loading.close();
        },
        async getApprovalTemp () {
            let loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.approvalTemplateList = [];
            let param = {
                currentPage: 1,
                pageSize: 1000,
                busiType: '',
                busiTypeName: '',
                templateName: '',
                // templateState: 1,
                formId: '',
                // userId: this.sonAccountObj.mainAccountId,
                appId: ''
            };
            let formData = await getApprovalTemplateList(param);
            if (formData) {
                if (formData.data && formData.data.length > 0) {
                    formData.data.forEach(item => {
                        if (item.templateState === 1) {
                            this.approvalTemplateList.push(item);
                        }
                    });
                }
                // this.approvalTemplateList = formData.data;
                // 2.获取授权的业务流模板列表
                this.getBusinessTemp(loading);
            }
        },
        handleClick () {

        },
        handleSelectionChange (val) {
            this.approvalChooseData = val;
        },
        handleSelectionChangeBusiness (val) {
            this.businessChooseData = val;
        },
        async getSonTempData (loading) {
            let param = {userId: this.sonAccountObj.userId};
            let res = await getSonTempData(param);
            if (res.state === 'success') {
                if (res.data) {
                    let businessTempIds = res.data.businessTempIds;
                    let approvalTemIds = res.data.approvalTemIds;
                    if (approvalTemIds && approvalTemIds.length > 0) {
                        for (let i = 0; i < this.approvalTemplateList.length; i++) {
                            let cur = this.approvalTemplateList[i];
                            if (approvalTemIds.indexOf(cur.id) !== -1) {
                                this.approvalChooseData.push(cur);
                                this.$refs.approvalTable.toggleRowSelection(cur);
                            }
                        }
                    }
                    if (businessTempIds && businessTempIds.length > 0) {
                        for (let i = 0; i < this.businessTemplateList.length; i++) {
                            let cur = this.businessTemplateList[i];
                            if (businessTempIds.indexOf(cur.id) !== -1) {
                                this.businessChooseData.push(cur);
                                this.$refs.businessTable.toggleRowSelection(cur);
                            }
                        }
                    }
                }
            }
            loading.close();
        },
        getChooseData () {
            let approvalChooseDataIds = [];
            this.approvalChooseData.forEach(item => {
                approvalChooseDataIds.push(item.id);
            });
            let businessChooseDataIds = [];
            this.businessChooseData.forEach(item => {
                businessChooseDataIds.push(item.id);
            });
            let param = {approvalTemIds: approvalChooseDataIds.join(','), businessTempIds: businessChooseDataIds.join(',')};
            return param;
        }

    }
};
</script>


// WEBPACK FOOTER //
// src/components/SonAccountAuth/SonAccountAuth.vue